import { html } from 'lit';
const VerticalCylinder =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.422 4.715C5.875 4.307 8.187 4 11.75 4s5.875.307 7.328.715c.724.204 1.27.442 1.655.704.354.24.716.601.764 1.092l.003.036v10.406c-.025.506-.387.88-.738 1.124-.381.265-.924.504-1.646.707-1.449.409-3.769.716-7.366.716s-5.917-.307-7.366-.716c-.722-.203-1.265-.442-1.646-.707-.35-.244-.713-.618-.737-1.124L2 16.935V6.547l.003-.036c.048-.49.41-.852.764-1.092.386-.262.93-.5 1.655-.704M3.5 8.162v8.61q.03.028.094.073c.195.136.564.317 1.197.496 1.261.355 3.427.659 6.959.659s5.698-.304 6.959-.66c.633-.178 1.002-.36 1.197-.495q.064-.045.094-.073v-8.61q-.372.155-.846.289c-1.445.409-3.772.716-7.404.716S5.79 8.86 4.346 8.45a8 8 0 0 1-.846-.289m16.542-1.751-.006.008zm-.249.187c-.219-.129-.574-.285-1.12-.438-1.268-.356-3.427-.66-6.923-.66s-5.655.304-6.922.66c-.547.153-.902.31-1.121.438.206.12.539.266 1.047.41 1.255.355 3.428.659 6.996.659s5.74-.304 6.996-.66c.508-.143.84-.289 1.047-.409M3.458 6.411l.006.008z" clip-rule="evenodd"/>
  </svg>
`;
export default VerticalCylinder;
